"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Camera = function Camera() {
  return _react2.default.createElement(
    "g",
    { id: "camera" },
    _react2.default.createElement("path", {
      d: "M178.564287,42.09998 L148.770246,103.387722 L41.6916617,103.387722 C18.5962807,103.287742 0,122.483903 0,146.179164 L0,415.725255 C0,439.520496 18.5962807,458.616677 41.6916617,458.616677 L458.308338,458.616677 C481.403719,458.616677 500,439.520496 500,415.725255 L500,146.179164 C500,122.383923 481.403719,103.287742 458.308338,103.287742 L351.129774,103.287742 L321.335733,42 L178.564287,42 L178.564287,42.09998 Z M249.95001,189.070586 C309.138172,189.070586 339.232154,220.064387 339.232154,280.95221 C339.232154,341.840032 309.138172,372.833833 249.95001,372.833833 C190.761848,372.833833 160.667866,341.840032 160.667866,280.95221 C160.667866,220.064387 190.761848,189.070586 249.95001,189.070586 Z",
      id: "Shape"
    })
  );
};

exports.default = Camera;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Camera.js
// module id = 2930
// module chunks = 4